import React, { useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import LoginImage from "../../../Assets/images/Login_image.png";
import { useNavigate } from "react-router-dom";
import { AuthOHelper } from "../../../Common/Config";
import { ToastContainer, toast } from "react-toastify";

const ForgetPasword = () => {
  const navigate = useNavigate();
  const [Payload, setPayload] = useState({});
  const [success, setSuccess] = useState(null);

  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleSubmit = async () => {
    if (document.getElementById("emailInput").checkValidity()) {
      setLoading(true);
      try {
        const result = await AuthOHelper().post(`/user/forgetRequest`, Payload);
        if (result.status === 200) {
          setSuccess(result.data.message);
          setLoading(false);
        }
      } catch (error) {
        console.log(error.response.data.error);
        toast.error(error.response.data.error);
        setLoading(false);
      }
    }
    setValidated(true);
  };
  const handleChange = (e) => {
    setPayload({
      ...Payload,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <>
      <ToastContainer />
      <Container className="py-5">
        <Breadcrumb>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/")}
            >
              Home
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/category/MicrosoftOffice")}
            >
              Shop
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => navigate("/login")}>
            <small className="Login_BreadCrumbs_style">Login</small>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <small className="Login_BreadCrumbs_style">Forget Password</small>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card className="Cart_Small_Card box_shadow">
          <Card.Body className="p-0">
            <Row>
              <Col md={6} xl={6} lg={6}>
                <img src={LoginImage} alt="AbouImg" className="Login_Img" />
              </Col>
              <Col
                md={6}
                xl={6}
                lg={6}
                className="About_Card_Para black_text p-5"
              >
                <Card.Title className="h6 mt-5">Forget Password</Card.Title>
                <Form validated={validated}>
                  <Form.Group className="py-4">
                    {success ? (
                      <div class="alert alert-success" role="alert">
                        {`${success}. Please Check your Email`}
                      </div>
                    ) : (
                      <>
                        <Form.Label className="text-muted">
                          <small>Enter Your Email Address</small>
                        </Form.Label>
                        <Form.Control
                          required
                          type="email"
                          id="emailInput"
                          placeholder="name@example.com"
                          name="email"
                          onChange={handleChange}
                          className="Login_InputFields"
                        />
                      </>
                    )}

                    <Button
                      variant="link"
                      className="forget_Password mt-4"
                      onClick={() => navigate("/login")}
                    >
                      <small>Cancel</small>
                    </Button>
                    <br />
                    <Button
                      className="SignIn_Btn mt-2 blue_bg"
                      onClick={() => handleSubmit()}
                    >
                      {loading ? (
                        <span
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        ""
                      )}
                      Submit
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default ForgetPasword;
